import { render, staticRenderFns } from "./AssetBlock.vue?vue&type=template&id=1ce5c21f&scoped=true&"
import script from "./AssetBlock.vue?vue&type=script&lang=js&"
export * from "./AssetBlock.vue?vue&type=script&lang=js&"
import style0 from "./AssetBlock.vue?vue&type=style&index=0&id=1ce5c21f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce5c21f",
  null
  
)

export default component.exports